import React, { useEffect, useState, useContext } from "react";
import { SchedulePushNotificationContext } from "@/context/SchedulePushNotificationContext";
import { BuildPath } from "@/helpers/Paths";
import ToolTipWrapper from "@/components/elements/Tooltip/ToolTipWrapper";
import { Tooltip as ReactTooltip } from "react-tooltip";

const NotificationTypeStep = ({ setStepOneValid } : { setStepOneValid : any}) => {
  const [appPreviewImage, setAppPreviewImage] = useState<string>(`${BuildPath()}/images/schedulepush/in-app-preview--grayscale.png`);
  const [appAndDevicePreviewImage, setAppAndDevicePreviewImage] = useState<string>(`${BuildPath()}/images/schedulepush/device-push-preview--grayscale.png`);
  const [selectedOption, setSelectedOption] = useState<"APP" | "APPANDDEVICE" | undefined>();
  const { store, setStore } = useContext(SchedulePushNotificationContext);

  //using state management to prepopulate the form
  useEffect(() => {
    if (store) {
      if (store.notificationType === 0) {
        onAppSelection();
      } else if (store.notificationType === 1) {
        onAppAndDeviceSelection();
      }
    } else {
      setSelectedOption(undefined);
      setStepOneValid(false);
    }
  }, []);

  const onAppSelection = () => {
    setSelectedOption("APP");
    setAppPreviewImage(`${BuildPath()}/images/schedulepush/in-app-preview.png`);
    setAppAndDevicePreviewImage(
      `${BuildPath()}/images/schedulepush/device-push-preview--grayscale.png`
    );
    setStore({
      ...store,
      notificationType: 0,
    });
    setStepOneValid(true);
  };

  const onAppAndDeviceSelection = () => {
    setSelectedOption("APPANDDEVICE");
    setAppPreviewImage(`${BuildPath()}/images/schedulepush/in-app-preview.png`);
    setAppAndDevicePreviewImage(
      `${BuildPath()}/images/schedulepush/device-push-preview.png`
    );
    setStore({
      ...store,
      notificationType: 1,
    });
    setStepOneValid(true);
  };

  return (
    <div className={`notification-type-step`}>
      <fieldset className="notification-type-options">
        <legend className="notification-type-question">
          What type of notification would you like to send?
        </legend>

        <div className="notification-type-option">
          <input
            className="radio-button"
            id="radio-app"
            type="radio"
            value="App"
            aria-label="Quiet Push"
            name="NotificationType"
            checked={selectedOption === "APP"}
            onChange={onAppSelection}
            autoFocus
          />
          <label htmlFor="radio-app">Quiet Push</label>
        </div>

        <div className="notification-type-option">
          <input
            id="radio-app-device"
            className="radio-button"
            type="radio"
            value="AppAndDevice"
            name="NotificationType"
            aria-label="Quiet + Standard Push"
            checked={selectedOption === "APPANDDEVICE"}
            onChange={onAppAndDeviceSelection}
          />
          <label htmlFor="radio-app-device">
            Quiet + Standard Push
          </label>
        </div>
      </fieldset>

      <div className="notification-type-preview">
        <button className="no-style-button preview preview-left" aria-label="Quiet Push" onClick={onAppSelection}>
          <img
            className="preview-image app-preview"
            data-testid="AppPreview"
            src={appPreviewImage}
            alt=""
          />
        </button>

        <button className="no-style-button preview device-preview" aria-label="Quiet Push and Standard Push" onClick={onAppAndDeviceSelection} >
          <img
            className="preview-image"
            data-testid="AppAndDevicePreview"
            alt=""
            src={appAndDevicePreviewImage}
          />
        </button>
      </div>
      
      <div className="notification-type-information">
        <div className="notification-type-info-item">
          <p>Quiet Push</p>
          <ToolTipWrapper id="notification-app-info" className="insights-devices">
            <ReactTooltip
              place="top"
              className="thrive-tooltip"
              delayHide={1000}
              id="notification-app-info"
            >
              <span>
                This sends a silent notification to the in-app notification centre and updates the app's icon badge. It does not send an alert to the user's lock screen or make a sound. Note: It may still appear in the device's notification list on some Android configurations
              </span>
            </ReactTooltip>
          </ToolTipWrapper>
        </div>

        <div className="notification-type-info-item">
          <p>+ Standard Push</p>
          <ToolTipWrapper id="notification-push-info" className="insights-devices">
            <ReactTooltip
              place="top"
              className="thrive-tooltip"
              delayHide={1000}
              id="notification-push-info"
            >
              <span>
                This sends a standard push alert with sound or vibration directly to a user's device, appearing on their lock screen and in their main notification centre. This action is all-inclusive and also performs all the functions of the 'Quiet Push' option.
              </span>
            </ReactTooltip>
          </ToolTipWrapper>
        </div>
      </div>

      <div className="notification-type-preview-warning">
        <p>Notification text will be truncated differently on different devices.</p>
      </div>
    </div>
  );
};

export default NotificationTypeStep;
